export const DynamicContentByTenant = {
  termsAndConditions: 'termsAndConditions',
  privacyPolicy: 'privacyPolicy'
};
